/** Error keys under `errors.validationErrors.*`, named as in Reactive Forms. */
export const ValidationErrorKey = {
  Min: 'min',
  Max: 'max',
  MinLength: 'minlength',
  MaxLength: 'maxlength',
} as const;
export type ValidationErrorKey = (typeof ValidationErrorKey)[keyof typeof ValidationErrorKey];

export interface ValidationErrorType {
  key: string;
  value: unknown | null;
  // A full translation key that replaces the `errors.validationErrors.<key>` lookup.
  messageKey?: string;
}
